import {
    selectDoc, event
} from "../utils/utils";
import {callAjaxForm} from "../helpers/service.ajaxform";

const props = {
    //Forgot Password
    passwordPage: selectDoc('#forgot-password'),
    passwordButton: selectDoc('#forgot-password form button.btn')
}

const initForgotPassword = () => {
    if(props.passwordPage) {
        event(props.passwordButton, 'click', function (e) {
            e.preventDefault()
            callAjaxForm(
                'ForgotPasswordForm',
                props.passwordButton,
                ['email'],
                {
                    "form_type": 'recover_customer_password',
                    "utf8": '✓'
                },
                '/account/recover',
                selectDoc('#default-response-container'),
                'g-recaptcha-forgot',
                selectDoc('#ForgotPasswordForm #default-messages-container')
            )
        })
    }
}

const initializer = () => {
    initForgotPassword()
}

export const Forgot = {
    init: () => initializer()
}
